module.exports = __webpack_public_path__ + "static/banner-8c643d21aeabb020eaa75551268a7ff1.png";